interface ErrorScreenProps {
  error?: Error | string | unknown;
}

/**
 * Error screen displayed when the app fails to bootstrap
 */
export const ErrorScreen = ({ error }: ErrorScreenProps) => {
  const errorMessage = error instanceof Error ? error.message : typeof error === 'string' ? error : '';

  return (
    <div style={{ display: 'flex', alignItems: 'center', height: '100vh' }}>
      <div style={{ margin: '0 25%' }}>
        <h2>An error occurred while attempting to retrieve identity provider information.</h2>
        {errorMessage && <p>{errorMessage}</p>}
      </div>
    </div>
  );
};
